<template>
  <v-content>
    <v-container>
      <v-alert
        v-model="show"
        v-bind="localAttrs"
        :dismissible="dismissible"
        :type="type"
        class="mb-4"
      >{{message}}</v-alert>
      <div v-html="confirmNext"></div>
    </v-container>
  </v-content>
</template>
<script>
import firebase from "firebase";
import VueCookies from "vue-cookies";
import {
  clientInviteReadApi,
  clientMemberAddApi
} from "@/config/appSettings";
export default {
  name: "userConfirm",
  data() {
    return {
      show: false,
      message: "",
      type: null,
      confirmNext: "",
      border: "left",
      coloredBorder: false,
      dismissible: false,
      auth: null,
      items: ["border", "outlined", "dense", "prominent"],
      variant: null
    };
  },
  computed: {
    localAttrs() {
      const attrs = {};

      if (this.variant === "border") {
        attrs.border = this.border;
        attrs.coloredBorder = this.coloredBorder;
      } else {
        attrs[this.variant] = true;
      }

      return attrs;
    }
  },
  created() {
    //console.log("HERE IS THE ROUTE DATA: ", this.$route.query);
    let confirmData = this.$route.query;
    // IF PASSWORD CHANGE
    let self = this;

    if (confirmData.show === "true") {
      this.show = true;
      this.message = confirmData.message;
      this.type = confirmData.type;
    }
    if (confirmData.mode === "resetPassword") {
      firebase
        .auth()
        .verifyPasswordResetCode(confirmData.oobCode)
        .then(() => {
          //console.log("RESET FOR EMAIL:", email);
          //console.log("CODE:", confirmData.oobCode);
          self.$router.push({
            name: "PasswordReset",
            query: { token: confirmData.oobCode }
          });
        })
        .catch(err => {
          // Invalid or expired action code. Ask user to try to reset the password
          // again.
          console.log(err);
          //self.$router.push("/");
        });
    }
    // IF EMAIL VERIFY
    if (confirmData.mode === "verifyEmail") {
      this.verifyEmail();
    }
  },
  methods: {
    async passwordSubmit(e) {
      e.preventDefault();

      let self = this;

      firebase
        .auth()
        .currentUser.updatePassword(self.password)
        .then(function() {
          //PASSWORD UPDATE SUCCESS
        })
        .catch(function(err) {
          //PASSWORD UPDATE FAILED
        });
    },
    async verifyEmail() {
      let confirmData = this.$route.query;
      // IF PASSWORD CHANGE
      let self = this;

      firebase
        .auth()
        .applyActionCode(confirmData.oobCode)
        .then(() => {
          // FORWARD TO LOGIN WITH URL PARAMS

        

          firebase
            .auth()
            .signOut()
            .then(() => {
              // CHECK IF THE COOKIE EXISTS

              self.$router.push({
                path: "/login",
                query: {
                  msg_show: true,
                  msg_type: "success",
                  msg:
                    "You have confirmed your email successfully. Log back In."
                }
              });
            });
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  }
};
</script>
<style scoped>
.success-alert {
  display: block;
}
.success-alert {
  display: block;
}
</style>